namespace $.$$ {

	const inner_outline_color = 'oklch( 60% 0 var(--mol_theme_hue) / .07 )' as any
	
	$mol_style_define( $shm_hitalama_map_widget_float, {
		
		// box: {
		// 	shadow: [{ inset: false, x: 0, y: 0, blur: 0, spread: '1px', color: $mol_theme.shade, }],
		// },
		
		// ":hover": {
		// 	outline: '1px solid var(--mol_theme_line)',
		// },
		'[shm_hitalama_map_widget_float_hovered]': {
			true: {
				Outline_top: { background: { color: $mol_theme.line } },
				Outline_left: { background: { color: $mol_theme.line } },
				Outline_bottom: { background: { color: $mol_theme.line } },
				Outline_right: { background: { color: $mol_theme.line } },
			},
			// '[shm_hitalama_map_widget_float_inner]': {
			// 	true: {
			// 		outline: '1px solid oklch( 60% 0 var(--mol_theme_hue) / .05 )',
			// 	},
			// },
		},
		'[shm_hitalama_map_widget_float_hovered][shm_hitalama_map_widget_float_inner]': {
			true: {
				Outline_top: { background: { color: inner_outline_color } },
				Outline_left: { background: { color: inner_outline_color } },
				Outline_bottom: { background: { color: inner_outline_color } },
				Outline_right: { background: { color: inner_outline_color } },
			},
		},

		'[shm_hitalama_map_widget_float_control]': {
			true: {
				Outline_top: { background: { color: $mol_theme.control } },
				Outline_left: { background: { color: $mol_theme.control } },
				Outline_bottom: { background: { color: $mol_theme.control } },
				Outline_right: { background: { color: $mol_theme.control } },
				":hover": {
					Outline_top: { background: { color: $mol_theme.control } },
					Outline_left: { background: { color: $mol_theme.control } },
					Outline_bottom: { background: { color: $mol_theme.control } },
					Outline_right: { background: { color: $mol_theme.control } },
				},
			},
		},

		'[shm_hitalama_map_widget_float_selected]': {
			true: {
				Outline_top: { background: { color: $mol_theme.current } },
				Outline_left: { background: { color: $mol_theme.current } },
				Outline_bottom: { background: { color: $mol_theme.current } },
				Outline_right: { background: { color: $mol_theme.current } },
				":hover": {
					Outline_top: { background: { color: $mol_theme.current } },
					Outline_left: { background: { color: $mol_theme.current } },
					Outline_bottom: { background: { color: $mol_theme.current } },
					Outline_right: { background: { color: $mol_theme.current } },
				},
			},
		},

		'[shm_hitalama_map_widget_float_dragged]': {
			true: {
				Outline_top: { background: { color: $mol_theme.focus } },
				Outline_left: { background: { color: $mol_theme.focus } },
				Outline_bottom: { background: { color: $mol_theme.focus } },
				Outline_right: { background: { color: $mol_theme.focus } },
				":hover": {
					Outline_top: { background: { color: $mol_theme.focus } },
					Outline_left: { background: { color: $mol_theme.focus } },
					Outline_bottom: { background: { color: $mol_theme.focus } },
					Outline_right: { background: { color: $mol_theme.focus } },
				},
			},
		},

		'[shm_hitalama_map_widget_float_locked_selected]': {
			true: {
				Outline_top: { background: { color: $mol_theme.line } },
				Outline_left: { background: { color: $mol_theme.line } },
				Outline_bottom: { background: { color: $mol_theme.line } },
				Outline_right: { background: { color: $mol_theme.line } },
			},
		},

		'[shm_hitalama_map_widget_float_locked]': {
			true: {
				userSelect: 'text',
				Top_edge: { pointerEvents: 'none' },
				Left_edge: { pointerEvents: 'none' },
				Bottom_edge: { pointerEvents: 'none' },
				Right_edge: { pointerEvents: 'none' },

				Left_top_edge_ratio: { pointerEvents: 'none' },
				Left_bottom_edge_ratio: { pointerEvents: 'none' },
				Right_bottom_edge_ratio: { pointerEvents: 'none' },
				Right_top_edge_ratio: { pointerEvents: 'none' },
				Top_left_edge_ratio: { pointerEvents: 'none' },
				Top_right_edge_ratio: { pointerEvents: 'none' },
				Bottom_left_edge_ratio: { pointerEvents: 'none' },
				Bottom_right_edge_ratio: { pointerEvents: 'none' },
				
				Top_left_edge: { opacity: 0, pointerEvents: 'none' },
				Top_right_edge: { opacity: 0, pointerEvents: 'none' },
				Bottom_left_edge: { opacity: 0, pointerEvents: 'none' },
				Bottom_right_edge: { opacity: 0, pointerEvents: 'none' },
				
				Drag_view: { pointerEvents: 'none' },
			},
		},

		// Arrow_settings: {
		// 	width: '200px',
		// 	height: '4px',
		// 	position: 'absolute',
		// 	// top: 0,
		// 	top: '50%',
		// 	right: 0,
		// 	background: {
		// 		color: 'red',
		// 	},
		// 	transformOrigin: '100% 100%',
		// 	transform: 'rotate(120deg)',
		// },

		Toolbar_top: {
			position: 'absolute',
			top: '-20px',
			// transformOrigin: '0 100%',
			// overflow: 'visible',
			transition: 'none',
			font: {
				size: '14px',
			},
			color: $mol_theme.control,
			opacity: 0.3,
			pointerEvents: 'none',
		},

		Link_str: {
			// opacity: 0.5,
		},

		Toolbar_type: {
			padding: {
				left: '0.5rem',
			},
		},

		Toolbar: {
			overflowX: 'auto',
		},

		Widget_link: {
			position: 'absolute',
			top: 0,
			right: 0,
			transformOrigin: 'top right',
			transition: 'none',
			zIndex: $mol_layer.popup,
		},

		Content_scroll: {
			width: '100%',
			height: '100%',
			padding: 0,
			border: {
				radius: 0,
				style: 'none',
			},
		},

		Widget_head: {
			background: {
				color: $mol_theme.card,
			},
			boxShadow: '0 -0.5rem 0.5rem -0.5rem hsla(0,0%,0%,0.25),0 0.5rem 0.5rem -0.5rem hsla(0,0%,0%,0.25)',
		},

		Fullsize_wrapper: {
			position: 'relative',
			height: 'auto',
			width: 'auto',
			flex: {
				direction: 'column',
			},
		},

		flex: {
			direction: 'column'
		},

		Widget_title: {
			['fieldSizing' as any]: 'content',
			flex: {
				grow: 0,
			},
		},
		
	} )
	
}
